module.exports = __webpack_public_path__ + "img/3-(2).9e87f6f4.jpg";